// Client-side demo dataset — mirrors the MCP server's synthetic data so the marketing site
// is fully interactive without auth. The real dashboard (Phase 3 auth) hits /v1/reliability.
export interface CarrierRow {
  carrier_code: string
  carrier_name: string
  on_time_pct: number
  transit_p50_days: number
  avg_delay_hours: number
  frequency_days: number
}

export const LANES: Record<string, CarrierRow[]> = {
  'CNSHA|NLRTM': [
    {
      carrier_code: 'MAEU',
      carrier_name: 'Maersk',
      on_time_pct: 78,
      transit_p50_days: 31,
      avg_delay_hours: 22,
      frequency_days: 7,
    },
    {
      carrier_code: 'MSCU',
      carrier_name: 'MSC',
      on_time_pct: 71,
      transit_p50_days: 33,
      avg_delay_hours: 38,
      frequency_days: 7,
    },
    {
      carrier_code: 'CMAU',
      carrier_name: 'CMA CGM',
      on_time_pct: 69,
      transit_p50_days: 32,
      avg_delay_hours: 41,
      frequency_days: 7,
    },
    {
      carrier_code: 'COSU',
      carrier_name: 'COSCO',
      on_time_pct: 64,
      transit_p50_days: 34,
      avg_delay_hours: 55,
      frequency_days: 7,
    },
    {
      carrier_code: 'HLCU',
      carrier_name: 'Hapag-Lloyd',
      on_time_pct: 74,
      transit_p50_days: 32,
      avg_delay_hours: 29,
      frequency_days: 7,
    },
  ],
  'CNSHA|USLAX': [
    {
      carrier_code: 'ONEY',
      carrier_name: 'ONE',
      on_time_pct: 81,
      transit_p50_days: 16,
      avg_delay_hours: 14,
      frequency_days: 7,
    },
    {
      carrier_code: 'MAEU',
      carrier_name: 'Maersk',
      on_time_pct: 76,
      transit_p50_days: 15,
      avg_delay_hours: 19,
      frequency_days: 7,
    },
    {
      carrier_code: 'MSCU',
      carrier_name: 'MSC',
      on_time_pct: 70,
      transit_p50_days: 17,
      avg_delay_hours: 33,
      frequency_days: 7,
    },
    {
      carrier_code: 'COSU',
      carrier_name: 'COSCO',
      on_time_pct: 67,
      transit_p50_days: 18,
      avg_delay_hours: 41,
      frequency_days: 7,
    },
  ],
  'VNSGN|DEHAM': [
    {
      carrier_code: 'CMAU',
      carrier_name: 'CMA CGM',
      on_time_pct: 72,
      transit_p50_days: 30,
      avg_delay_hours: 31,
      frequency_days: 7,
    },
    {
      carrier_code: 'MAEU',
      carrier_name: 'Maersk',
      on_time_pct: 75,
      transit_p50_days: 29,
      avg_delay_hours: 26,
      frequency_days: 7,
    },
    {
      carrier_code: 'ONEY',
      carrier_name: 'ONE',
      on_time_pct: 70,
      transit_p50_days: 31,
      avg_delay_hours: 35,
      frequency_days: 14,
    },
  ],
}

export const POPULAR_LANES = [
  { origin: 'CNSHA', destination: 'NLRTM', label: 'Shanghai → Rotterdam' },
  { origin: 'CNSHA', destination: 'USLAX', label: 'Shanghai → Los Angeles' },
  { origin: 'VNSGN', destination: 'DEHAM', label: 'Ho Chi Minh → Hamburg' },
]

export function lookup(origin: string, destination: string): CarrierRow[] {
  const rows = LANES[`${origin.toUpperCase()}|${destination.toUpperCase()}`] ?? []
  return [...rows].sort((a, b) => b.on_time_pct - a.on_time_pct)
}
